import React from 'react'
import MusicSideNav from './MusicSideNav'
import LinkMedia from './LinkMedia'

function Music() {
  const sideNav={
    padding: "10px 15px 0",
    height: "100%",
    boxSizing: "border-box"
  }
  return (
    <div className='flex'>
    <div style={{ flex: '1 1 280px', maxWidth:'280px', textAlign:'left' }}>
      <div style={sideNav}>
  <MusicSideNav />
  </div>
  </div> 
  </div>
  )
}

export default Music

  
